import React, { useMemo } from 'react'
import T from 'prop-types'
import { Typography } from '@mui/material'
import { INVENTORY_STATE_EXPIRED } from 'lib/inventoryStates'

import DateCell from 'components/atoms/DateCell'

export default function InventoryExpiresAtCell({ value, row }) {
  const expired = useMemo(
    () => row?.original.state === INVENTORY_STATE_EXPIRED,
    [row.original.state]
  )
  return (
    <Typography
      component="span"
      variant="body2"
      color={!expired ? 'textPrimary' : 'error'}
    >
      <DateCell value={value} />
    </Typography>
  )
}

InventoryExpiresAtCell.propTypes = {
  value: T.node,
  row: T.object,
  others: T.object,
}
